exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".read-more[data-v-44fab6cb]{max-height:6.25rem}.read-more[data-v-44fab6cb]:after{background:linear-gradient(0deg,#fff,hsla(0,0%,90.2%,0) 100%,hsla(0,0%,90.2%,0) 0);content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}", ""]);

